import { render, staticRenderFns } from "./cartLevel.vue?vue&type=template&id=633699c2&scoped=true&"
import script from "./cartLevel.vue?vue&type=script&lang=ts&"
export * from "./cartLevel.vue?vue&type=script&lang=ts&"
import style0 from "./cartLevel.vue?vue&type=style&index=0&id=633699c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633699c2",
  null
  
)

export default component.exports